import { styled } from '@mui/material/styles';

export const Icon = styled('span')(({ theme }) => ({
  borderRadius: 6,
  width: 20,
  height: 20,
  boxShadow: 'inset 0 0 0 2px #d7d7d7, inset 0 -2px 0 #d7d7d7',
  background: theme.palette.background.paper,
  'input:hover ~ &': {
    boxShadow: 'inset 0 0 0 2px #5980FF, inset 0 -2px 0 #5980FF',
  },
  'input:disabled ~ &': {
    boxShadow: 'none',
    background: theme.palette.background.default,
  },
}));

export const CheckedIcon = styled(Icon)(({ theme: { palette } }) => ({
  background: palette.secondary.light,
  boxShadow: `inset 0 0 0 2px ${palette.secondary.main}, inset 0 -2px 0 ${palette.secondary.main}`,
  '&:before': {
    display: 'block',
    width: 14,
    height: 10,
    backgroundImage:
      'url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns=\'http://www.w3.org/2000/svg\' viewBox=\'0 0 16 11\'%3E%3Cpath' +
      ' d=\'m0 4.813 1.391-1.375 4.87 4.812L14.609 0 16 1.375 6.26 11 0 4.813Z\' fill=\'%235980FF\'/%3E%3C/svg%3E")',
    content: '""',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    margin: '5px 1px 5px 3px',
  },
}));
